import StartClinicalServicePopup from "../../../components/patient/clinical-services/popups/StartClinicalServicePopup";
import { minorAilments } from "../../../components/patient/text/data";

const initialState = {
  clinicalServiceLocal: null,
  clinicalServices: [],
  clinicalServicesSmall: [],
  clinicalServiceObj: null,
  clinicalServiceName: null,
  clinicalServiceSteps: null,
  loading: false,
  error: null,
  medicalConditions: [],
  medications: [],
  medicalHistory: null,
  amrEducation: [],
  amrCurrentCard: null,
  amrUpdatedCards: [],
  amrInitialValueOfCards: [],
  amrClickedMedication: null,
};

const clinicalServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case "RESET_STATE":
      return initialState;
    case "UPDATE_CLINICAL_SERVICE_LOCAL":
      return {
        ...state,
        clinicalServiceLocal: { ...action.payload },
        loading: false,
      };
    case "UPDATE_AMR_EDUCATION_LOCAL":
      return {
        ...state,
        amrEducation: [...action.payload],
        loading: false,
      };
    case "RESET_AMR_EDUCATION_LOCAL":
      return {
        ...state,
        amrEducation: [],
        loading: false,
      };
    case "SET_AMR_UPDATED_REVIEWCARDS_LOCAL":
      return {
        ...state,
        amrUpdatedCards: action.payload,
        loading: false,
      };
    case "SET_AMR_INITIAL_VALUE_REVIEWCARDS_LOCAL":
      return {
        ...state,
        amrInitialValueOfCards: action.payload,
        loading: false,
      };
    case "UPDATE_AMR_CURRENT_REVIEWCARD_LOCAL":
      return {
        ...state,
        amrCurrentCard: action.payload,
        loading: false,
      };
    case "RESET_AMR_CURRENT_REVIEWCARD_LOCAL":
      return {
        ...state,
        amrCurrentCard: null,
        loading: false,
      };
    case "SET_AMR_CLICKED_MEDICATION_LOCAL":
      return {
        ...state,
        amrClickedMedication: action.payload,
        loading: false,
      };
    case "RESET_AMR_CLICKED_MEDICATION_LOCAL":
      return {
        ...state,
        amrClickedMedication: null,
        loading: false,
      };
    case "CREATE_CLINICAL_SERVICE_SUCCESS":
      return {
        ...state,
        clinicalServiceObj: { ...action.payload },
        loading: false,
      };
    case "CREATE_CLINICAL_SERVICE_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_DEFAULT_STEPS":
      return {
        ...state,
        clinicalServiceObj: {
          ...state.clinicalServiceObj,
          initialAssessment: {
            ...state.clinicalServiceObj.initialAssessment,
            initialAssessmentForm: {
              ...state.clinicalServiceObj.initialAssessment
                .initialAssessmentForm,
              currentStep: 1, // Updated value for currentStep
              currentSubStep: 1, // Updated value for currentSubStep
            },
          },
        },
        loading: false,
      };
    case "FETCH_CLINICAL_SERVICES_SUCCESS":
      return {
        ...state,
        clinicalServicesSmall: action.payload,
        loading: false,
      };
    case "FETCH_CLINICAL_SERVICES_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "FETCH_CLINICAL_SERVICE_SUCCESS":
      return {
        ...state,
        clinicalServiceObj: action.payload,
        loading: false,
      };
    case "FETCH_CLINICAL_SERVICE_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_CLINICAL_SERVICE_SUCCESS":
      return {
        ...state,
        clinicalServiceObj: { ...action.payload },
        loading: false,
      };
    case "UPDATE_CLINICAL_SERVICE_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "DELETE_CLINICAL_SERVICE_SUCCESS":
      return {
        ...state,
        clinicalServicesSmall: {
          ...state.clinicalServicesSmall,
          minorAilments: state.clinicalServicesSmall.minorAilments.filter(x => x.id !== action.payload)
        },
        clinicalServiceName: null,
        clinicalServiceObj: null,
        loading: false,
      };
    case "DELETE_CLINICAL_SERVICE_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "SET_CLINICAL_SERVICE_NAME_SUCCESS":
      return {
        ...state,
        clinicalServiceName: action.payload,
        loading: false,
      };
    case "SET_CLINICAL_SERVICE_STEPS_SUCCESS":
      return {
        ...state,
        clinicalServiceSteps: [...action.payload],
        loading: false,
      };
    case "SET_CLINICAL_SERVICE_NAME_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "CREATE_MEDICATION_REVIEW_SUCCESS":
      return {
        ...state,
        clinicalServiceObj: { ...action.payload },
        loading: false,
      };
    case "CREATE_MEDICATION_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "FETCH_MEDICATION_REVIEW_SUCCESS": {
      return {
        ...state,
        clinicalServiceObj: action.payload || {},
        loading: false,
      };
    }
    case "FETCH_MEDICATION_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_MEDICATION_REVIEW_SUCCESS": {
      const currentObj = state.clinicalServiceObj || {};
      const incomingObj = action.payload || {};

      // Resolve existing medications path (supports both shapes just in case)
      const existingIA = currentObj.initialAssessment?.initialAssessmentForm;
      const incomingIA = incomingObj.initialAssessment?.initialAssessmentForm;

      const existingMedications = existingIA?.medications?.medications || currentObj?.medications?.medications || [];
      const incomingMedications = incomingIA?.medications?.medications || incomingObj?.medications?.medications || [];

      // Merge medications by id (prefer medicationId if present, else id)
      const toKey = (m) => (m?.medicationId ?? m?.id);
      const mergedById = new Map(existingMedications.map((m) => [toKey(m), m]));
      incomingMedications.forEach((m) => {
        const key = toKey(m);
        if (key == null) return;
        const prev = mergedById.get(key) || {};
        mergedById.set(key, { ...prev, ...m });
      });
      // Only keep medications present in the incoming payload (handles deletions)
      const mergedMedicationsArray = incomingMedications
        .map((m) => mergedById.get(toKey(m)))
        .filter(Boolean);

      const preservedProfileAnalysisClicked = incomingIA?.medications?.profileAnalysisClicked !== undefined 
        ? incomingIA?.medications?.profileAnalysisClicked 
        : existingIA?.medications?.profileAnalysisClicked;

      const existingEducation = existingIA?.education || {};
      const incomingEducation = incomingIA?.education || {};
      const toVaccineName = (vaccine) => {
        if (typeof vaccine === "string" || typeof vaccine === "number") {
          return String(vaccine).trim();
        }
        const nameValue = vaccine?.name ?? vaccine?.value ?? vaccine?.label;
        if (typeof nameValue === "string") return nameValue.trim();
        if (!nameValue || typeof nameValue !== "object") return "";
        const candidate =
          nameValue.name ??
          nameValue.value ??
          nameValue.label ??
          nameValue?.name?.name ??
          nameValue?.name?.value ??
          nameValue?.name?.label;
        return typeof candidate === "string" ? candidate.trim() : "";
      };
      const toSchedule = (education) =>
        Array.isArray(education?.vaccineSchedule) ? education.vaccineSchedule : [];
      const existingSchedule = toSchedule(existingEducation);
      const incomingSchedule = toSchedule(incomingEducation);
      const hasIncomingVaccineSchedule = Object.prototype.hasOwnProperty.call(
        incomingEducation,
        "vaccineSchedule"
      );
      const existingScheduleByKey = new Map(
        existingSchedule.map((item) => [item?.id ?? toVaccineName(item), item])
      );
      const mergedVaccineSchedule = incomingSchedule.map((item) => {
        const nextItem = item && typeof item === "object" ? item : { name: item };
        const previous =
          existingScheduleByKey.get(nextItem?.id ?? toVaccineName(nextItem)) || {};
        return {
          ...previous,
          ...nextItem,
          name: toVaccineName(nextItem) || toVaccineName(previous),
        };
      });
      const mergedEducation = {
        ...existingEducation,
        ...incomingEducation,
        ...(hasIncomingVaccineSchedule
          ? {
              vaccineSchedule:
                incomingSchedule.length > 0
                  ? mergedVaccineSchedule
                  : incomingSchedule,
            }
          : {}),
      };
      
      const nextObj = {
        ...currentObj,
        ...incomingObj,
        initialAssessment: {
          ...currentObj.initialAssessment,
          ...incomingObj.initialAssessment,
          initialAssessmentForm: {
            ...existingIA,
            ...incomingIA,
            currentStep: incomingIA?.currentStep ?? existingIA?.currentStep,
            currentSubStep: incomingIA?.currentSubStep ?? existingIA?.currentSubStep,
            medications: {
              ...(existingIA?.medications || {}),
              ...(incomingIA?.medications || {}),
              // Preserve profileAnalysisClicked from existing if not in incoming (backend might not return it)
              profileAnalysisClicked: preservedProfileAnalysisClicked,
              medications: mergedMedicationsArray,
            },
            education: mergedEducation,
            healthAndWellness: incomingIA?.healthAndWellness ?? incomingObj?.healthAndWellness,
          },
        },
      };

      return {
        ...state,
        clinicalServiceObj: nextObj,
        loading: false,
      };
    }
    case "UPDATE_MEDICATION_REVIEW_LOCAL": {
      const currentObj = state.clinicalServiceObj || {};
      const existingIA = currentObj.initialAssessment?.initialAssessmentForm || {};
      const incoming = action.payload || {};

      const mergedInitialAssessmentForm = {
        ...existingIA,
        // preserve/override step metadata
        currentStep: incoming.currentStep ?? existingIA.currentStep,
        currentSubStep: incoming.currentSubStep ?? existingIA.currentSubStep,
        // merge documentation if provided
        documentation: incoming.documentation
          ? { ...(existingIA.documentation || {}), ...(incoming.documentation || {}) }
          : existingIA.documentation,
      };

      const nextObj = {
        ...currentObj,
        initialAssessment: {
          ...currentObj.initialAssessment,
          initialAssessmentForm: mergedInitialAssessmentForm,
        },
      };

      return {
        ...state,
        clinicalServiceObj: nextObj,
        loading: false,
      };
    }
    case "UPDATE_MEDICATION_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "SET_AMR_ADDITIONAL_MEDICATIONS_LOCAL": {
      const currentObj = state.clinicalServiceObj || {};
      const existingIA = currentObj.initialAssessment?.initialAssessmentForm;
      const existingMeds = existingIA?.medications || {};
      return {
        ...state,
        clinicalServiceObj: {
          ...currentObj,
          initialAssessment: {
            ...currentObj.initialAssessment,
            initialAssessmentForm: {
              ...existingIA,
              medications: {
                ...existingMeds,
                ...action.payload,
              },
            },
          },
        },
      };
    }
    case "DELETE_MEDICATION_REVIEW_SUCCESS":
      return {
        ...state,        
        clinicalServicesSmall: {
          ...state.clinicalServicesSmall,
          medicationReviews: state.clinicalServicesSmall.medicationReviews.filter(x => x.id !== action.payload)
        },
        clinicalServiceName: null,
        clinicalServiceObj: null,
        loading: false,
      };
    case "DELETE_MEDICATION_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "FETCH_MEDICAL_CONDITIONS_SUCCESS":
      return {
        ...state,
        medicalConditions: { ...action.payload },
        loading: false,
      };
    case "FETCH_MEDICAL_CONDITIONS_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "CREATE_MEDICAL_CONDITION_SUCCESS":
      return {
        ...state,
        medicalConditions: [
          ...(state.medicalConditions ? [state.medicalConditions] : []),
          ...(action.payload ? [action.payload] : []),
        ],
        loading: false,
      };
    case "CREATE_MEDICAL_CONDITION_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_MEDICAL_CONDITION_SUCCESS_FROM_CHART": {
      // Early return if payload is invalid
      if (!action.payload?.id) {
        return { ...state, loading: false };
      }

      const { id, conditionName, name, ...updatedPayload } = action.payload;
      const normalizedPayload = { ...updatedPayload, id, name: conditionName || name };

      // Helper function to update condition in array
      const updateConditionInArray = (conditions) => {
        if (!Array.isArray(conditions)) return conditions;
        const index = conditions.findIndex((c) => c.id === id);
        if (index === -1) return conditions;
        const updated = [...conditions];
        updated[index] = normalizedPayload;
        return updated;
      };

      // Update medical conditions
      const medicalConditions = state.medicalConditions?.medicalConditions || [];
      const updatedMedicalConditions = updateConditionInArray(medicalConditions);

      // Update medical history
      const existingHistory = state.medicalHistory || {};
      const updatedHistoryConditions = updateConditionInArray(existingHistory.medicalConditions);

      return {
        ...state,
        medicalConditions: {
          medicalConditions: updatedMedicalConditions,
        },
        medicalHistory: {
          ...existingHistory,
          medicalConditions: updatedHistoryConditions,
        },
        loading: false,
      };
    }
    case "UPDATE_MEDICAL_CONDITION_SUCCESS":
      const conditions = [...state.medicalConditions];
      const updatedCondIndex = conditions.findIndex(
        (i) => i.id === action.payload.id
      );
      conditions[updatedCondIndex] = action.payload;
      return {
        ...state,
        medicalConditions: conditions,
        loading: false,
      };
    case "UPDATE_MEDICAL_CONDITION_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "DELETE_MEDICAL_CONDITION_SUCCESS":
      const updatedMedicalConditions =
        state.medicalConditions.medicalConditions.filter(
          (val) => val.id !== action.payload
        );
      return {
        ...state,
        medicalConditions: {
          medicalConditions: updatedMedicalConditions,
        },
        loading: false,
      };
    case "DELETE_MEDICAL_CONDITION_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "FETCH_MEDICATIONS_SUCCESS":
      return {
        ...state,
        medications: action.payload.medications.map((med) => ({
          ...med,
          displayName: `${med.medicationName} ${med.route} [${med.dosage} ${med.form} ${med.frequency}]`,
        })),
        loading: false,
      };
    case "FETCH_MEDICATIONS_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "CREATE_MEDICATION_SUCCESS":
      return {
        ...state,
        medications: [
          ...state.medications,
          ...action.payload.medications.map((med) => ({
            ...med,
            displayName: `${med.medicationName} ${med.route} [${med.dosage} ${med.form} ${med.frequency}]`,
          })),
        ],
        loading: false,
      };
    case "CREATE_MEDICATION_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_MEDICATION_SUCCESS":
      let updatedMedications = [...state.medications];

      // Iterate through the payload medications
      action.payload.medications.forEach((newMed) => {
        newMed = {
          ...newMed,
          displayName: `${newMed.medicationName} ${newMed.route} [${newMed.dosage} ${newMed.form} ${newMed.frequency}]`,
        };
        // Find the index of the medication in the current state
        const index = updatedMedications.findIndex(
          (med) => med.id === newMed.id
        );
        if (index !== -1) {
          // If medication exists in the state, update it
          updatedMedications[index] = {
            ...updatedMedications[index],
            ...newMed,
          };
        } else {
          // If medication does not exist in the state, add it
          updatedMedications.push(newMed);
        }
      });

      return {
        ...state,
        medications: updatedMedications,
        loading: false,
      };
    case "UPDATE_MEDICATION_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "DELETE_MEDICATION_SUCCESS":
      return {
        ...state,
        medications: state.medications.filter(
          (med) => med.id !== action.payload
        ),
        loading: false,
      };
    case "DELETE_MEDICATION_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case "FETCH_MEDICAL_HISTORY_SUCCESS":
      return {
        ...state,
        medicalHistory: { ...action.payload },
        loading: false,
      };
    case "FETCH_MEDICAL_HISTORY_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "CREATE_MEDICAL_HISTORY_SUCCESS":
      return {
        ...state,
        medicalConditions: {
          medicalConditions: [
            ...action.payload.medicalConditions.map((val) => {
              return { ...val, conditionName: val?.name };
            }),
          ],
        },
        medicalHistory: { ...action.payload },
        loading: false,
      };
    case "CREATE_MEDICAL_HISTORY_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_MEDICAL_HISTORY_SUCCESS":
      let medicalHistoryState = { ...state.medicalHistory };

      if (action.payload.medicalConditions?.length > 0) {
        let medicalConditions = [...medicalHistoryState.medicalConditions];
        medicalConditions = medicalConditions.map((val) => {
          return { ...val, conditionName: val.name };
        });
        const medicalConditionIndexToUpdate = medicalConditions.findIndex(
          (val) => val.id === action.payload.medicalConditions[0]?.id
        );
        medicalConditions[medicalConditionIndexToUpdate] =
          action.payload.medicalConditions[0];
        medicalConditions[medicalConditionIndexToUpdate].conditionName =
          action.payload.medicalConditions[0].name;

        medicalHistoryState = {
          ...medicalHistoryState,
          medicalConditions: medicalConditions,
        };
      }

      if (action.payload.surgeries?.length > 0) {
        let surgeries = [...medicalHistoryState.surgeries];
        surgeries = surgeries.map((val) => {
          return { ...val, conditionName: val.name };
        });
        const surgeryToUpdate = surgeries.findIndex(
          (val) => val.id === action.payload.surgeries[0]?.id
        );
        surgeries[surgeryToUpdate] = action.payload.surgeries[0];
        surgeries[surgeryToUpdate].conditionName =
          action.payload.surgeries[0].name;

        medicalHistoryState = { ...medicalHistoryState, surgeries: surgeries };
      }

      if (action.payload.medicalStudies?.length > 0) {
        let medicalStudies = [...medicalHistoryState.medicalStudies];
        medicalStudies = medicalStudies.map((val) => {
          return { ...val, conditionName: val.name };
        });
        const medicalStudyIndexToUpdate = medicalStudies.findIndex(
          (val) => val.id === action.payload.medicalStudies[0]?.id
        );
        medicalStudies[medicalStudyIndexToUpdate] =
          action.payload.medicalStudies[0];
        medicalStudies[medicalStudyIndexToUpdate].conditionName =
          action.payload.medicalStudies[0].name;

        medicalHistoryState = {
          ...medicalHistoryState,
          medicalStudies: medicalStudies,
        };
      }
      return {
        ...state,
        medicalConditions: {
          medicalConditions: medicalHistoryState.medicalConditions,
        },
        medicalHistory: medicalHistoryState,
        loading: false,
      };
    case "UPDATE_MEDICAL_HISTORY_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "DELETE_SURGERY_SUCCESS":
      let surgeryId = action.payload;
      return {
        ...state,
        medicalHistory: {
          ...state.medicalHistory,
          surgeries: state.medicalHistory.surgeries.filter(
            (surgery) => surgery.id !== surgeryId
          ),
        },
        loading: false,
      };
    case "DELETE_SURGERY_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_MINOR_AILMENT_SUCCESS":
      const { id, status, rxDetails } = action.payload;
      return {
        ...state,
        clinicalServicesSmall: {
          ...state.clinicalServicesSmall,
          minorAilments: state.clinicalServicesSmall.minorAilments.map((i) =>
            i.id === id ? { ...i, status: status, rxDetails: rxDetails } : i
          ),
        },
        loading: false,
      };
    case "UPDATE_MINOR_AILMENT_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case "UPDATE_STATUS_MEDICATION_REVIEW_SUCCESS":
      const { medReviewId, medReviewStatus } = action.payload;
      return {
        ...state,
        clinicalServicesSmall: {
          ...state.clinicalServicesSmall,
          medicationReviews: state.clinicalServicesSmall.medicationReviews.map(
            (i) =>
              i.id === medReviewId ? { ...i, status: medReviewStatus } : i
          ),
        },
        loading: false,
      };
    case "UPDATE_STATUS_MEDICATION_REVIEW_FAILURE":
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default clinicalServiceReducer;
